import React from 'react';
import {
    useWindowSize,
    isMobile,
} from '@frontend/jetlend-web-ui/src/utils/responsive';
import Section from '@app/ui/Section/Section';
import Image from '@app/components/Image/Image';

import styles from './FeaturesSection.module.scss';
import { FeaturesSectionWithBlocksType } from '@app/models/sections/features';

export interface IProps {
    /**
     * Информация о преимуществах
     */
    features: FeaturesSectionWithBlocksType;
}

/**
 * Компонент для отрисовки преимуществ академии
 */
export default function FeaturesSection({ features }: IProps) {
    const { width: screenWidth } = useWindowSize();
    const isMobileScreen = isMobile(screenWidth);
    const mobileTitle = features?.title_mobile?.length > 0 ? features?.title_mobile : 'Преимущества';
    const title = isMobileScreen ? mobileTitle : features?.title;

    return (
        <Section animation={false}>
            <div className={styles['container']}>
                <div className={styles['title-wrapper']}>
                    <span className={styles['title']}>{title}</span>
                </div>
                <div className={styles['cards']}>
                    {features?.blocks?.map(item => (
                        <div key={item?.title} className={styles['card']}>
                            <div className={styles['card-header']}>
                                <div className={styles['card-title']}>{item?.title}</div>
                                <div className={styles['card-text']}>{item?.description}</div>
                            </div>
                            <div className={styles['card-image']}>
                                <Image src={item?.image} alt="" fill />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Section>
    );
}
